// extracted by mini-css-extract-plugin
export var orderSummary = "_tr-0";
export var showMoreLessButton = "_tr-1";